import { render, staticRenderFns } from "./tab-action-list.vue?vue&type=template&id=3b1602c0&scoped=true"
import script from "./tab-action-list.vue?vue&type=script&lang=js"
export * from "./tab-action-list.vue?vue&type=script&lang=js"
import style0 from "./tab-action-list.vue?vue&type=style&index=0&id=3b1602c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1602c0",
  null
  
)

export default component.exports